import { APP_BASE_HREF } from '@angular/common';
import { Component, Inject, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { OAuthService } from 'angular-oauth2-oidc';
import { ConfigurationService, LanguageService, SearchService } from '@un-fao/lightforms-lib/lightforms-services';
import { environment } from 'src/environments/environment';
import { ActivatedRoute } from '@angular/router';
import { ConsumerConfigurationService } from './consumer-configuration.service';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.css'],
    standalone: false
})
export class AppComponent implements OnInit 
{
  textDir: string;

  constructor(
    @Inject(APP_BASE_HREF) public baseHref: string, 
    public translateService: TranslateService, 
    public languageService: LanguageService,
    private route: ActivatedRoute,
    public consumerConfigService: ConsumerConfigurationService,
    public configService: ConfigurationService,
    public searchService: SearchService
  ) 
  {
    this.textDir = languageService.textDir;
  }

  ngOnInit(): void 
  {
    this.route.fragment.subscribe(async res => 
    {
      //Injection of the menu in the library to fill the header accordingly
      let items = await this.consumerConfigService.loadMenu(environment.space);
      let mapConfig = await this.consumerConfigService.loadMapConfig();

      this.configService.env.menu = items;
      this.configService.env.mapConfig = mapConfig;
    });
  }
  
  onLanguageChange(event: string)
  {
    this.translateService.use(event);
  }
}
